import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { SessionTimeConfigAddEdit, SessionTimeConfigListing } from './Pages';

export const SessionTimeConfigRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SessionTimeConfigListing} />
        <Route exact path={`${match.path}/addEdit`} component={SessionTimeConfigAddEdit} />
    </Fragment>
);
